import axios from 'axios'
const instance = axios.create({
    baseURL: 'https://xyjl.shuzizhouyi.cn/api',
    // baseURL: 'http://localhost:5001', 
    // baseURL: 'http://192.168.0.115:5001/',
    // baseURL: 'http://47.93.121.213:5010',
    timeout: 5000,
    headers: { 'Content-Type': 'application/json' }
});

instance.interceptors.request.use(function (config) {
    config.headers.token = localStorage.getItem("token");
    return config;
}, function (error) {
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

export default instance;